import { render, staticRenderFns } from "./PrintingRollsNew.vue?vue&type=template&id=272e9e46"
import script from "./PrintingRollsNew.vue?vue&type=script&lang=js"
export * from "./PrintingRollsNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports